export function TargetPersonIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_9_15)">
        <path
          d="M12 6.74414C13.4768 6.74414 14.6777 7.94507 14.6777 9.42188C14.6777 10.8987 13.4768 12.0996 12 12.0996C10.5232 12.0996 9.32227 10.8987 9.32227 9.42188C9.32227 7.94507 10.5232 6.74414 12 6.74414ZM12 8.66211C11.5814 8.66211 11.2402 9.00324 11.2402 9.42188C11.2402 9.84051 11.5814 10.1816 12 10.1816C12.4186 10.1816 12.7598 9.84051 12.7598 9.42188C12.7598 9.00324 12.4186 8.66211 12 8.66211Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path
          d="M12 11.9004C14.4246 11.9004 16.3965 13.8724 16.3965 16.2969C16.3965 16.8267 15.9674 17.2559 15.4375 17.2559C14.9076 17.2559 14.4785 16.8267 14.4785 16.2969C14.4785 14.9305 13.3663 13.8184 12 13.8184C10.6337 13.8184 9.52148 14.9305 9.52148 16.2969C9.52148 16.8267 9.09236 17.2559 8.5625 17.2559C8.03264 17.2559 7.60352 16.8267 7.60352 16.2969C7.60352 13.8724 9.57543 11.9004 12 11.9004Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
        <path
          d="M12 0.900391C12.5299 0.900391 12.959 1.32951 12.959 1.85938V2.49609C17.4701 2.94331 21.0567 6.52987 21.5039 11.041H22.1406C22.6705 11.041 23.0996 11.4701 23.0996 12C23.0996 12.5299 22.6705 12.959 22.1406 12.959H21.5039C21.0567 17.4701 17.4701 21.0557 12.959 21.5029V22.1406C12.959 22.6705 12.5299 23.0996 12 23.0996C11.4701 23.0996 11.041 22.6705 11.041 22.1406V21.5029C6.52992 21.0557 2.94331 17.4701 2.49609 12.959H1.85938C1.32951 12.959 0.900391 12.5299 0.900391 12C0.900391 11.4701 1.32951 11.041 1.85938 11.041H2.49609C2.94331 6.52987 6.52987 2.94331 11.041 2.49609V1.85938C11.041 1.32951 11.4701 0.900391 12 0.900391ZM12 4.36523C7.79049 4.36523 4.36523 7.79049 4.36523 12C4.36523 16.2095 7.79049 19.6348 12 19.6348C16.2095 19.6348 19.6348 16.2095 19.6348 12C19.6348 7.79049 16.2095 4.36523 12 4.36523Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_9_15">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
